// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contentPlaceholder":"jWW4B","defaultMask":"GnaoM"};